import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IInvoice } from "@shared/interfaces";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class InvoicesService {
  private invoices$ = new BehaviorSubject<IInvoice[]>([]);

  constructor(private http: HttpClient) {}

  getInvoices() {
    return this.invoices$.asObservable();
  }

  setInvoices(invoices: IInvoice[]) {
    this.invoices$.next(invoices);
  }

  loadInvoices(page: number = 1, count: number = 50) {
    const url = environment.apiUrl + `/user/invoices?page=${page}&count=${count}`;
    return this.http.get(url);
  }

  loadPostamats() {
    const url = environment.apiUrl + `/postamates`;
    return this.http.get(url);
  }

  searchPostamats(value: string) {
    const url = environment.apiUrl + `/searchPostamates?name=${value}`;
    return this.http.get<any>(url);
  }

  getPostamats(page:number, value?: string) {
    const url = environment.apiUrl + `/searchPostamates?page=${page}&name=${value?value:''}`;
    return this.http.get<any>(url);
  }

  getDeliveryOptions() {
    const url = environment.apiUrl + `/deliveryOptions`;
    return this.http.get(url);
  }

  getPaymentId(id:number, body:any){
    let url = environment.apiUrl + `/user/payment/${id}`;
    return this.http.post(url, body, {observe: 'response'});
  }

  checkPayment(body:any){
    let url = environment.apiUrl + `/checkPayment`;
    return this.http.post(url, body, {observe: 'response'});
  }

  getInvoicePdf(id:number){
    const url = environment.apiUrl + `/user/invoicePdf/${id}`;
    return this.http.get(url, {responseType: 'blob' as 'json'});
  }

  getLocation(value: string) {
    const url = environment.apiUrl +`/ltpost/location?keyword=${value}`;
    return this.http.get(url);
  }

  getStreetByLocationID(location_id: number) {
    const url = environment.apiUrl +`/ltpost/location/${location_id}`;
    return this.http.get(url);
  }

  getHouseByStreetID(location_id: number, street_id: number) {
    const url = environment.apiUrl +`/ltpost/location/${location_id}/street/${street_id}`;
    return this.http.get(url);
  }

  getZIpCOdeByLocationID(location_id: number) {
    const url = environment.apiUrl +`/ltpost/postalCode/${location_id}`;
    return this.http.get(url);
  }

  getDeliveryLp() {
      let url = environment.apiUrl + '/deliveryLp';
      return this.http.get(url, {});
  }

}